module.exports = __webpack_public_path__ + "static/img/card.2a457e18.png";